import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Banner.css";
import Typical from "react-typical";
import { Fade } from "react-reveal";

const Banner = () => {
  return (
    <div className="banner-container py-4 px-2">
      <Container>
        <Row>
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={8}
            className="d-flex justify-content-center flex-column"
          >
            <Fade right>
              <h1 className="banner-title">
                Hi, I'm{" "}
                <span className="text-danger">Md. Ahanaf Tahmid Islam</span>
              </h1>
              <p className="fs-3">
                I'm a{" "}
                <Typical
                  steps={[
                    "junior software developer",
                    2000,
                    "front-end web developer",
                    2000,
                    "tech enthusiast",
                    2000,
                    "computer science engineer",
                    2000,
                  ]}
                  loop={Infinity}
                  wrapper="b"
                />
              </p>
              <div>
                <button className="btn btn-danger me-4">Hire Me</button>
                <button className="btn btn-danger me-4">
                  <a
                    style={{ textDecoration: "none", color: "white" }}
                    // href="https://drive.google.com/uc?id=17H4BVuHoZMg9cDq9CKyCKguhQzr5__Jx&export=download"
                    href="https://drive.google.com/file/d/1zjs4MJ4FqkT6a17FFhtNgdYnZERUIOlg/view?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download My Resume
                  </a>
                </button>
              </div>

              <div className="pt-4">
                <p className="fs-4">Find Me</p>
                <div>
                  <a
                    href="https://www.linkedin.com/in/tahmidbd/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-linkedin-in text-white fs-3 pe-2"></i>
                  </a>
                  &nbsp;&nbsp;
                  <a
                    href="https://github.com/Tahmid-islam"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i class="fab fa-github text-white fs-3 pe-2"></i>
                  </a>
                  &nbsp;&nbsp;
                  <a
                    href="https://www.facebook.com/ahanaf.tahmid.islam"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-facebook text-white fs-3 pe-2"></i>
                  </a>
                  &nbsp;&nbsp;
                  <a
                    href="https://www.instagram.com/____ahanaf____/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-instagram text-white fs-3 pe-2"></i>
                  </a>
                </div>
              </div>
            </Fade>
          </Col>
          <Col xs={12} sm={12} md={12} lg={4} className="my-img">
            <Fade left>
              <img
                className="img-fluid"
                src="https://i.ibb.co/dMx3Wsq/Tahmid-Portfolio-Image.png"
                alt=""
              />
            </Fade>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
